<main class="parent-signin d-flex align-items-center justify-content-center p-3">
  <section class="main-page-content-block-secondary w-100 p-4 text-center" aria-labelledby="sparkTitle">
    <h1 id="sparkTitle" class="text-white mb-4">Spark</h1>
    <div *ngIf="loading" role="status" class="py-3">
      <div class="spinner-border" aria-hidden="true"></div>
      <p class="mt-3 mb-0">Signing in...</p>
    </div>
    <ng-container *ngIf="!loading">
      <div *ngIf="errorMessage" id="parentSigninError" role="alert"
           [ngClass]="isError ? 'alert alert-danger' : 'h5 mb-3'">
        {{ errorMessage }}
      </div>
      <p class="fs-6 mb-4">To sign in, open the client's page in Client Portal and select <strong>Go to Spark</strong>.</p>
      <a *ngIf="clientPortalUrl" id="returnToClientPortal" class="btn btn-lg btn-primary w-100" [href]="clientPortalUrl">Return to Client Portal</a>
    </ng-container>
  </section>
</main>
